// extracted by mini-css-extract-plugin
module.exports = {"popup":"DeletePopup_popup__YN9v1","info":"DeletePopup_info__KX_0S","controls":"DeletePopup_controls___HtKd"};